import moment from 'moment-timezone';
import {Observable} from 'rxjs';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import ChildApi from 'web-app/api/child-api';

export const sleep = (childId, value) => {
    if (moment.isMoment(value)) {
        return RESTClient.postAuthenticatedObservable('daycare/sleep/putchildtosleep', {
            childId,
            startTime: value.format(),
        });
    } else {
        return RESTClient.postAuthenticatedObservable('daycare/sleep/putchildtosleep', {
            childId,
            offset: value,
        });
    }
};

export const wakeUp = (childId, value) => {
    if (moment.isMoment(value)) {
        return RESTClient.postAuthenticatedObservable('daycare/sleep/napisover', {
            childId,
            endTime: value.format(),
            rest: 0,
        });
    } else {
        return RESTClient.postAuthenticatedObservable('daycare/sleep/napisover', {
            childId,
            offset: value,
            rest: 0,
        });
    }
};

export const deleteSleep = napId => {
    return RESTClient.deleteAuthenticated('daycare/sleep/delete', {
        napId,
    });
};

export const checkOnChild = childId => Observable.fromPromise(ChildApi.registerAction(childId, 'SLEEP_CHECK'));
